import { navItems } from "@/mocks/cg51";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 font-heading text-base font-black text-accent-400">51</span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                cg<span className="text-primary-600">51</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              cg51 是一站式栏目导航，把热点专楼、吃瓜合集、分区盘点与话题大全收拢到一页，按兴趣直达内容，省去来回翻找的时间。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">快速栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((n) => (
                <li key={n.label}>
                  <a href={n.href} className="inline-flex items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-700">
                    <i className="ri-corner-down-right-line text-xs text-accent-600" /> {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">内容分区盘点</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {["内娱", "影视", "音乐", "体育", "电竞", "海外", "科技", "财经"].map((z) => (
                <li key={z}>
                  <a href="#zones" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:bg-accent-200 hover:text-accent-900">
                    {z}区
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs leading-relaxed text-foreground-600">
              本页内容为演示展示，按钮与合集仅作浏览示意，不构成任何真实立场或事实主张。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 cg51 栏目导航 · 热点专楼 吃瓜合集 分区盘点 话题大全</p>
          <p className="inline-flex items-center gap-1.5 text-xs text-foreground-600">
            <i className="ri-heart-line text-primary-600" /> 按兴趣直达内容，热门讨论一页掌握
          </p>
        </div>
      </div>
    </footer>
  );
}